import React from "react";
import SectionWidget from "./SectionWidget";
import SolidWarningIcon from "../../assets/icons/SolidWarningIcon";

const SectionMain = ({ firstMountRef, section, sectionId, dashboardId }) => {
  const { widgets } = section;
  return (
    <div
      className={`auto-rows-auto ${
        widgets.length ? "grid gap-2	lg:grid-cols-2	md:grid-cols-1" : ""
      } `}
    >
      {widgets.length ? (
        widgets.map((widget, index) => {
          return (
            <SectionWidget
              firstMountRef={firstMountRef}
              widgetId={index}
              sectionId={sectionId}
              dashboardId={dashboardId}
              msgId={widget.message_id}
              key={widget.message_id}
              widget={widget}
            />
          );
        })
      ) : (
        <div className="flex flex-col justify-center items-center w-full h-56">
          <SolidWarningIcon className="w-8 h-8 mb-2 text-orange-300" />
          <h3 className="text-zinc-300">No Widgets Found</h3>
        </div>
      )}
    </div>
  );
};

export default SectionMain;
